import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Pipe to bypass Angular's built-in URL sanitization.
 * 
 * SECURITY NOTE: This pipe disables Angular's built-in sanitization for resource URLs.
 * It should ONLY be used for trusted content from controlled sources (e.g., internal APIs,
 * static configuration). Never use this pipe with user-generated or untrusted external content
 * as it may expose the application to XSS attacks.
 * 
 * Usage: Only for embedding trusted iframe sources and resource URLs from application configuration.
 */
@Pipe({
  name: 'htmlSafe',
  standalone: true
})
export class HtmlSafePipe implements PipeTransform {

  constructor(private readonly domSanitizer: DomSanitizer) {}
  transform(url: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR - Intentional bypass for trusted iframe URLs from internal API configuration
  }

}
